module.exports = __webpack_public_path__ + "media/images/question_mark-d8c44b31.png";